import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useToasts } from '../hooks/useToasts';
/** Capa fixed bottom-right que renderiza el stack de toasts.
 *  Montar una sola vez (en Layout). */
export default function Toasts() {
    const { toasts, dismiss } = useToasts();
    if (toasts.length === 0)
        return null;
    return (_jsx("div", { className: "toast-stack", role: "status", "aria-live": "polite", children: toasts.map((t) => (_jsxs("div", { className: `toast toast-${t.kind}`, children: [_jsxs("div", { className: "toast-body", children: [_jsx("div", { className: "toast-title", children: t.title }), t.msg && _jsx("div", { className: "toast-msg", children: t.msg })] }), _jsx("button", { type: "button", className: "toast-close", onClick: () => dismiss(t.id), "aria-label": "cerrar", children: "\u00D7" })] }, t.id))) }));
}
